// components/GeneratedThumb/ThumbBadge.tsx — the corner pill overlaid on a thumb
// (duration today; Live reuses this for LIVE badges and viewer-count pills — same
// corner slots, same treatment). Defined once instead of copy-pasted per card.
import styled from 'styled-components';

export type ThumbBadgeCorner = 'br' | 'tr' | 'bl' | 'tl';

const CORNER_POSITION: Record<ThumbBadgeCorner, string> = {
  br: 'right: 6px; bottom: 6px;',
  tr: 'right: 6px; top: 6px;',
  bl: 'left: 6px; bottom: 6px;',
  tl: 'left: 6px; top: 6px;',
};

export const ThumbBadge = styled.span<{ $corner?: ThumbBadgeCorner; $compact?: boolean }>`
  position: absolute;
  ${({ $corner = 'br' }) => CORNER_POSITION[$corner]}
  z-index: 1;
  padding: ${({ $compact }) => ($compact ? '1px 4px' : '2px 6px')};
  border-radius: ${({ $compact, theme }) => ($compact ? '3px' : theme.radius.sm)};
  background: rgba(0, 0, 0, 0.72);
  color: #fff;
  font-family: ${({ theme }) => theme.font.mono};
  font-variant-numeric: tabular-nums;
  font-size: ${({ $compact }) => ($compact ? '9px' : '11px')};
  line-height: 1.4;
  pointer-events: none;
`;
